import { render, staticRenderFns } from "./MatterSecurityDepositForm.vue?vue&type=template&id=24ba940f&"
import script from "./MatterSecurityDepositForm.vue?vue&type=script&lang=js&"
export * from "./MatterSecurityDepositForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterSecurityDepositForm.vue?vue&type=style&index=0&id=24ba940f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports